import { render, staticRenderFns } from "./ReferentForm.vue?vue&type=template&id=32b936d4"
import script from "./ReferentForm.vue?vue&type=script&lang=js"
export * from "./ReferentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports